import * as actionTypes from './actionTypes';

const initialState = {
  couponData: null,
  loading: false,
  error: null,
};

const validateCouponReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VALIDATE_COUPON_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.VALIDATE_COUPON_SUCCESS:
      return { ...state, loading: false, couponData: action.payload };
    case actionTypes.VALIDATE_COUPON_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case actionTypes.CLEAR_VALIDATED_COUPON:
      return { ...initialState };
    default:
      return state;
  }
};

export default validateCouponReducer;
